<template>
  <div class="nav-footer">
    <!-- 定宽布局 -->
    <div class="container">
      <!-- 联系方式-->
      <div class="f-info">
        <h2>联系方式</h2>
        <div class="blink"></div>
        <ul>
          <li class="iconfont icon-jigou">
            公司：么么卡科技（北京）有限公司
          </li>
          <li class="iconfont icon-weibiaoti-">公司传真：010-53324498</li>
          <li class="iconfont icon-youxiang">公司邮箱：shuo@momoca.net</li>
          <li class="iconfont icon-youxiang">
            <a href="https://beian.miit.gov.cn/#/Integrated/index">备案号：京ICP备17059135号-1、京ICP备17059135号-2</a>
          </li>
          <li class="iconfont icon-dizhi">
            地址：北京市海淀区知春路76号（写字楼）1号楼5层1-7
          </li>
        </ul>
      </div>
      <!-- 公司简介 -->
      <div class="f-jj">
        <h2>么么卡科技（北京）有限公司</h2>
        <p>Momoka Technology (Beijing) Co., Ltd</p>
        <div class="blink"></div>
        <p>
          么么卡科技（北京）有限公司，致力于成为一家提供领先的、全面优质的基础软件、应用软件开发技术与相关服务的企业。我们秉持专业、合作的理念，相信：稳定、灵活、高效的专业服务一定能为客户带来更优质领先的产品与服务。
        </p>
      </div>
      <!-- 导航栏 -->
      <div class="f-list">
        <h2>导航</h2>
        <div class="blink"></div>
        <ul>
          <li><a href="/">网站首页</a></li>
          <li><a href="/#/ac1">行业资讯</a></li>
          <!-- <li><a href="/#/ac2">纠纷处理</a></li> -->
          <!-- <li><a href="/#/xy">用户协议</a></li> -->
          <!-- <li><a href="/#/ac3">用户权益保障措施</a></li> -->
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "nav-footer",
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.nav-footer {
  width: 100%;
  height: 350px;
  background: #2d3237;

  margin-top: 40px;

  .container {
    height: 100%;
    @include flex();

    // 联系方式
    .f-info {
      h2 {
        font-size: 18px;
        color: #fff;
      }

      .blink {
        width: 100px;
        height: 3px;
        background-color: #fff;
        margin: 20px 0;
      }

      ul {
        li {

          font-size: 14px;
          color: rgba(255, 255, 255, 0.4);
          margin: 10px 0;

          a {
            color: rgba(255, 255, 255, 0.4);
            font-size: 14px;
          }
        }
      }
    }

    // 公司简介
    .f-jj {
      width: 400px;

      h2 {
        font-size: 18px;
        color: #fff;
      }

      .blink {
        width: 100px;
        height: 3px;
        background-color: #fff;
        margin: 20px 0;
      }

      p {
        color: rgba(255, 255, 255, 0.4);
        font-size: 14px;
        line-height: 30px;
      }
    }

    // 导航栏
    .f-list {
      h2 {
        font-size: 18px;
        color: #fff;
      }

      .blink {
        width: 100px;
        height: 3px;
        background-color: #fff;
        margin: 20px 0;
      }

      ul {
        li {
          width: 200px;
          font-size: 14px;
          color: rgba(255, 255, 255, 0.4);
          margin: 10px 0;

          a {
            font-size: 14px;
            color: rgba(255, 255, 255, 0.4);
          }
        }
      }
    }
  }
}
</style>